var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4216 9.7217C26.0718 9.09803 25.6304 8 24.7294 8H7.26717C6.36616 8 5.92471 9.09806 6.57499 9.72172L15.3064 18.0957C15.6933 18.4668 16.3039 18.4667 16.6908 18.0957L25.4216 9.7217Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6918 20.2949C16.3049 20.6658 15.6943 20.6658 15.3075 20.2949L5.69215 11.0739C5.05639 10.4642 4 10.9148 4 11.7957V22.3432C4 22.8955 4.44772 23.3432 5 23.3432H27C27.5523 23.3432 28 22.8955 28 22.3432V11.7956C28 10.9147 26.9436 10.4641 26.3079 11.0738L16.6918 20.2949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.d36cc7ff1690b25d8c0a2501d87f0353.svg";
export { ForwardRef as ReactComponent };